import { render } from "./poi-card.presentational.vue?vue&type=template&id=434a79bd"
import script from "./poi-card.presentational.vue?vue&type=script&lang=js"
export * from "./poi-card.presentational.vue?vue&type=script&lang=js"

import "./poi-card.presentational.vue?vue&type=style&index=0&id=434a79bd&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__